import { useRef, useState, useCallback } from "react";
import { MoveHorizontal } from "lucide-react";

export default function BeforeAfter({ before, after, labelBefore = "Avant", labelAfter = "Après", testid = "before-after-slider" }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  const update = useCallback((clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(97, Math.max(3, pct)));
  }, []);

  const onPointerDown = (e) => {
    e.currentTarget.setPointerCapture(e.pointerId);
    update(e.clientX);
  };

  return (
    <div
      ref={ref}
      data-testid={testid}
      className="ba-handle relative w-full aspect-[4/3] sm:aspect-[16/10] overflow-hidden select-none bg-[#242529]"
      onPointerDown={onPointerDown}
      onPointerMove={(e) => e.buttons === 1 && update(e.clientX)}
      role="slider"
      aria-label="Comparateur avant après"
      aria-valuenow={Math.round(pos)}
      aria-valuemin={0}
      aria-valuemax={100}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "ArrowLeft") setPos((p) => Math.max(3, p - 4));
        if (e.key === "ArrowRight") setPos((p) => Math.min(97, p + 4));
      }}
    >
      <img src={after} alt={labelAfter} className="absolute inset-0 h-full w-full object-cover" draggable={false} loading="lazy" />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img
          src={before}
          alt={labelBefore}
          className="absolute inset-0 h-full w-full object-cover grayscale"
          style={{ width: ref.current ? ref.current.getBoundingClientRect().width : "100vw", maxWidth: "none" }}
          draggable={false}
          loading="lazy"
        />
      </div>
      <div className="absolute top-0 bottom-0 w-px bg-[#F6F3EB]" style={{ left: `${pos}%` }}>
        <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 flex h-10 w-10 items-center justify-center rounded-full bg-[#F6F3EB] text-[#121212] shadow-lg">
          <MoveHorizontal className="h-5 w-5" />
        </span>
      </div>
      <span className="absolute left-3 top-3 bg-[#121212]/85 text-[#F6F3EB] font-mono text-[10px] uppercase tracking-[0.2em] px-3 py-1.5">
        {labelBefore}
      </span>
      <span className="absolute right-3 top-3 bg-[#8C7B5D] text-[#121212] font-mono text-[10px] uppercase tracking-[0.2em] px-3 py-1.5">
        {labelAfter}
      </span>
    </div>
  );
}
